@if (newAnalystRatings) {
  <a [tdWbOverlayToggle]="tooltipTemplate"
     role="button"
     class="td-wb-step-tracker__editable-link"
     tdWbOverlayPosition="start-bottom"
     tdWbOverlaySize="small">
    <span translate="tdWb.analystRatingTooltip.ANALYST_RATINGS"></span>
  </a>
}

<ng-template #tooltipTemplate>
  <td-wb-overlay class="td-wb-analyst-ratings-tooltip__overlay">
    <p class="td-wb-analyst-ratings-tooltip__help">
      <span translate="tdWb.analystRatingTooltip.TEXT_HELP"></span>
      <a class="td-wb-analyst-ratings-tooltip__link"
         tdWbHelpLink="home_page_ratings">
        <span translate="tdWb.analystRatingTooltip.HELP_LINK"></span>
      </a>
    </p>
    <p class="td-wb-analyst-ratings-tooltip__legal"
       translate="tdWb.analystRatingTooltip.TEXT_LEGAL">
    </p>
  </td-wb-overlay>
</ng-template>

